import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter62.json";
import Head from "next/head";
export default function Chapter_62() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
     <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Julian, Iamblichus, polytheism, Neoplatonism, theurgy, Helios, Rome, festivals, rituals, philosophy, harmony, cosmic order, tradition, restoration, spirituality."
        ></meta>
        <meta
          property="og:title"
          content="Julian the Philosopher: Restoring Rome’s Ancient Polytheistic Spiritual Order"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Emperor Julian (361–363 CE) sought to restore Rome’s polytheistic heritage, inspired by Iamblichan Neoplatonism and theurgy. He envisioned a harmonious cosmos, uniting divine order, nature, and humanity. Rejecting Imperial Christianity’s exclusivity, Julian aimed to revive festivals, rituals, and philosophical traditions, preserving Rome’s sacred cultural identity in balance with the ancient Gods."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=62"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=62"
        ></meta>
        <meta
          name="twitter:title"
          content="Julian the Philosopher: Restoring Rome’s Ancient Polytheistic Spiritual Order"
        ></meta>
        <meta
          name="twitter:description"
          content="Julian, Rome’s last pagan emperor, championed polytheism against rising Imperial Christianity. Influenced by Iamblichus, he promoted theurgy, self-knowledge, and cosmic harmony. His reforms funded temples, revived rituals, and honored Helios as divine unity’s source. Though short-lived, Julian’s vision sought to reunite Rome with its ancient Gods and restore a pluralistic spiritual order."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=62" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
